module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_07.1191cf16.jpg";